<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" md="10" offset-md="1">
          <div class="d-flex justify-content-between align-items-end mb-4">
            <h3 class="h3-responsive text-muted font-weight-bold">契約情報</h3>
            <mdb-btn v-if="requestable" rounded color="primary" @click.native="() => requestFormModal = true">
              有料ライセンス申し込み
            </mdb-btn>
          </div>
          <mdb-card v-if="account">
            <mdb-card-body class="mb-4">
              <mdb-row>
                <mdb-col col="12" class="py-2 py-md-4">
                  <p class="font-weight-bold">プラン名</p>
                  <p class="pl-2">{{ account.licensedPlan.planName }}</p>
                </mdb-col>
                <mdb-col col="12" class="py-2 py-md-4">
                  <p class="font-weight-bold">概要</p>
                  <p class="pl-2 text-pre-wrap">{{ account.licensedPlan.planDescription }}</p>
                </mdb-col>
                <mdb-col col="12" class="py-2 py-md-4">
                  <p class="font-weight-bold">会議室設定</p>
                  <mdb-tbl responsive bordered class="text-nowrap">
                    <mdb-tbl-head>
                      <tr>
                        <th>利用料金</th>
                        <th>入室者数上限</th>
                        <th>会議時間制限</th>
                      </tr>
                    </mdb-tbl-head>
                    <mdb-tbl-body>
                      <tr>
                        <td>
                          {{
                            account.licensedPlan.contractType === 'free' ?
                            '無料' : toJPY(account.licensedPlan.price, true)
                          }}
                        </td>
                        <td>{{ account.licensedPlan.roomCapacity }}人</td>
                        <td>{{ account.licensedPlan.maxDuration ? `${account.licensedPlan.maxDuration}分` : 'なし' }}</td>
                      </tr>
                    </mdb-tbl-body>
                  </mdb-tbl>
                </mdb-col>
                <mdb-col col="12" class="py-2 py-md-4" v-if="account.licensedPlan.contractType !== 'free' && account.licensedPlan.licensedRoomOptions.length">
                  <p class="font-weight-bold">オプション</p>
                  <mdb-tbl responsive bordered class="text-nowrap">
                    <mdb-tbl-head>
                      <tr>
                        <th></th>
                        <th>利用料金</th>
                        <th>オプション説明</th>
                      </tr>
                    </mdb-tbl-head>
                    <mdb-tbl-body>
                      <tr v-for="licensedRoomOption in account.licensedPlan.licensedRoomOptions" :key="licensedRoomOption.id">
                        <td>{{ licensedRoomOption.optionName }}</td>
                        <td>{{ toJPY(licensedRoomOption.price, true) }}</td>
                        <td>{{ licensedRoomOption.optionDescription }}</td>
                      </tr>
                    </mdb-tbl-body>
                  </mdb-tbl>
                </mdb-col>
                <mdb-col col="12" class="py-2 py-md-4" v-if="account.reservedRoom">
                  <div class="d-flex justify-content-between align-items-end mb-3">
                    <span class="font-weight-bold">専用会議室</span>
                    <div class="d-flex">
                      <mdb-btn rounded outline="success" @click.native="showReservedRoomQRModal = true" size="sm">
                        <mdb-icon icon="qrcode" class="mr-2"/>QRコード表示
                      </mdb-btn>
                      <mdb-btn rounded outline="primary" @click.native="() => { onInputEditReservedRoomId(); editReservedRoomIdModal = true }" size="sm">
                        <mdb-icon icon="edit" class="mr-2"/>専用会議室名変更
                      </mdb-btn>
                    </div>
                  </div>
                  <mdb-tbl responsive bordered class="text-nowrap">
                    <mdb-tbl-body>
                      <tr>
                        <td>専用会議室名</td>
                        <td>{{ account.reservedRoom.roomId }}</td>
                      </tr>
                      <tr>
                        <td>会議URL</td>
                        <td>
                          <a :href="appURL + account.reservedRoom.roomId" style="color: #007bff;">{{ appURL + account.reservedRoom.roomId }}</a>
                        </td>
                      </tr>
                    </mdb-tbl-body>
                  </mdb-tbl>
                </mdb-col>
                <mdb-col col="12" class="mt-3" v-if="account.licensedPlan.contractType !== 'free'">
                  <p class="font-weight-bold">請求先情報</p>
                  <div class="mt-2 mb-4">
                    <mdb-tbl responsive bordered class="text-nowrap">
                      <mdb-tbl-body>
                        <tr>
                          <td>請求先</td>
                          <td>{{ account.invoiceTo === 'organization' ? '会社' : '個人' }}</td>
                        </tr>
                        <tr>
                          <td>宛先</td>
                          <td>{{ account.invoiceTo === 'organization' ? account.organization : user.name }}</td>
                        </tr>
                        <tr v-if="account.organization">
                          <td>会社名団体名</td>
                          <td>{{ account.organization }}</td>
                        </tr>
                        <tr v-if="account.division">
                          <td>部署名</td>
                          <td>{{ account.division }}</td>
                        </tr>
                        <tr>
                          <td>住所</td>
                          <td>{{ account.address }}</td>
                        </tr>
                        <tr>
                          <td>電話番号</td>
                          <td>{{ account.phone }}</td>
                        </tr>
                      </mdb-tbl-body>
                    </mdb-tbl>
                  </div>
                </mdb-col>
                <mdb-col col="12" class="py-2 py-md-4" v-if="account.licensedPlan.contractType !== 'free'">
                  <p class="font-weight-bold">お支払いと適用期間</p>
                  <mdb-tbl responsive bordered class="text-nowrap">
                    <mdb-tbl-head>
                      <tr>
                        <th>請求金額計(一年契約)</th>
                        <th>お支払い状況</th>
                        <th v-if="!account.licensedPlan.paymentConfirmedAt">お支払い期日</th>
                        <th>ライセンス適用期間</th>
                      </tr>
                    </mdb-tbl-head>
                    <mdb-tbl-body>
                      <tr>
                        <td>
                          {{ toJPY(totalLicensedPrice * 12) }}
                        </td>
                        <td class="text-center">
                          <span v-if="account.licensedPlan.paymentConfirmedAt" class="text-success">
                            <mdb-icon icon="check"/>
                          </span>
                          <span v-else class="text-danger">
                            <mdb-icon icon="times"/>
                          </span>
                        </td>
                        <td v-if="!account.licensedPlan.paymentConfirmedAt">
                          {{ account.licensedPlan.paymentAt | moment('YYYY/MM/DD HH:mm') }}
                        </td>
                        <td>
                          {{ account.licensedPlan.licenseStartAt | moment('YYYY/MM/DD HH:mm') }}
                          ~ {{ account.licensedPlan.licenseExpiredAt | moment('YYYY/MM/DD HH:mm') }}
                        </td>
                      </tr>
                    </mdb-tbl-body>
                  </mdb-tbl>
                  <div v-if="!account.licensedPlan.paymentConfirmedAt">
                    <small class="text-muted font-weight-bold">※Waaarpにご登録のメールアドレス宛に、請求書をお送りさせていただきます。</small>
                    <small class="text-muted font-weight-bold d-block">※お支払期日までに入金が確認出来なかった場合には、有料ライセンスは無効となります。</small>
                  </div>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <modal
      :modal="requestFormModal"
      size="xl"
      title="有料ライセンス申込みフォーム"
      @close="requestFormModal = false"
      :disableCancelButton="true"
      :disableOkButton="true"
      :scrollable="true"
    >
    <validation-observer v-slot="{ handleSubmit }">
      <form novalidate @submit.prevent="() => { validated = true; handleSubmit(onSubmit) }" class="secondary-form">
        <mdb-row>
          <mdb-col col="12" class="mt-3">
            <label class="text-muted font-weight-bold">ライセンスプランを選択して下さい（必須）</label>
            <custom-mdb-input
              type="radio"
              class="my-4"
              v-for="licensePlanMaster in licensePlanMasters.filter(resource => resource.contractType !== 'free')"
              :key="licensePlanMaster.id"
              :id="licensePlanMaster.id.toString()"
              :radioValue="licensePlanMaster.id.toString()"
              v-model="licensePlan.licensePlanMasterId"
              :label="licensePlanMaster.planName"
            >
              <div class="mt-2 mb-4">
                <mdb-tbl responsive bordered class="text-nowrap">
                  <mdb-tbl-head>
                    <tr>
                      <th>利用料金</th>
                      <th>入室者数上限</th>
                      <th>会議時間制限</th>
                    </tr>
                  </mdb-tbl-head>
                  <mdb-tbl-body>
                    <tr>
                      <td>{{ toJPY(licensePlanMaster.price, true) }}</td>
                      <td>{{ licensePlanMaster.roomCapacity }}人</td>
                      <td>{{ licensePlanMaster.maxDuration ? `${licensePlanMaster.maxDuration}分` : 'なし' }}</td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </custom-mdb-input>
          </mdb-col>
          <mdb-col col="12" class="mt-3">
            <label class="text-muted font-weight-bold">オプションを選択して下さい（任意）</label>
            <custom-mdb-input
              type="checkbox"
              class="my-4"
              v-for="roomOption in roomOptions"
              :key="roomOption.resource.id"
              :id="roomOption.resource.optionName"
              v-model="roomOption.checked"
              :label="roomOption.resource.optionName"
            >
              <div class="mt-2 mb-4">
                <mdb-tbl responsive bordered class="text-nowrap">
                  <mdb-tbl-head>
                    <tr>
                      <th>利用料金</th>
                      <th>オプション説明</th>
                    </tr>
                  </mdb-tbl-head>
                  <mdb-tbl-body>
                    <tr>
                      <td>{{ toJPY(roomOption.resource.price, true) }}</td>
                      <td>
                        <span>{{ roomOption.resource.optionDescription }}</span>
                        <div v-if="roomOption.resource.optionType == 'roomReserve' && roomOption.checked">
                          <custom-mdb-input
                            v-model="licensePlan.reservedRoomId"
                            :customValidation="true"
                            :isValid="validReservedRoomId"
                            :invalidFeedback="reservedRoomIdinvalidFeedback"
                            :validFeedback='`入力された会議室名"${licensePlan.reservedRoomId}"は利用可能です`'
                            @input="onInputReservedRoomId"
                            label="専用会議室名"
                            name="roomName"
                            type="text"
                            class="mb-2"
                          />
                          <mdb-btn
                            v-if="enabledCheckReservedRoomId"
                            :class="{ 'disabled': httpRequesting }"
                            @click.native="checkReservedRoomId"
                            rounded
                            outline="primary"
                            size="sm"
                          >
                            <span v-if="httpRequesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            会議室名確認
                          </mdb-btn>
                        </div>
                      </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </custom-mdb-input>
          </mdb-col>
          <mdb-col md="8" offset-md="2" class="mt-3">
            <label class="text-muted font-weight-bold">請求先を選択してください（必須）</label>
            <mdb-form-inline>
              <custom-mdb-input
                type="radio"
                class="my-4"
                radioValue="personal"
                id="invoiceToPersonal"
                v-model="editAccount.invoiceTo"
                label="個人"
              />
              <custom-mdb-input
                type="radio"
                class="my-4"
                radioValue="organization"
                id="invoiceToOrganization"
                v-model="editAccount.invoiceTo"
                label="会社"
              />
            </mdb-form-inline>
          </mdb-col>
          <mdb-col md="8" offset-md="2" class="mt-3" v-show="editAccount.invoiceTo">
            <label class="text-muted font-weight-bold">請求先情報を入力してください</label>
          </mdb-col>
          <mdb-col md="8" offset-md="2" v-show="editAccount.invoiceTo">
            <validation-provider
              name="会社名・団体名"
              :rules="`${editAccount.invoiceTo === 'organization' || editAccount.organization.length > 255 ? 'required|max:255' : ''}`"
              v-slot="{ errors }"
              immediate
            >
              <custom-mdb-input
                class="mb-0"
                label="会社名・団体名"
                name="organization"
                type="text"
                v-model="editAccount.organization"
                :customValidation="editAccount.invoiceTo === 'organization' || editAccount.organization.length > 255"
                :isValid="errors.length == 0"
                :invalidFeedback="errors[0]"
              />
            </validation-provider>
          </mdb-col>
          <mdb-col md="8" offset-md="2" v-show="editAccount.invoiceTo">
            <validation-provider name="部署名" rules="max:255" v-slot="{ errors }" immediate>
              <custom-mdb-input
                class="mb-0"
                label="部署名"
                name="division"
                type="text"
                v-model="editAccount.division"
                :customValidation="editAccount.division.length > 255"
                :isValid="errors.length == 0"
                :invalidFeedback="errors[0]"
              />
            </validation-provider>
          </mdb-col>
          <mdb-col md="8" offset-md="2" v-show="editAccount.invoiceTo">
            <validation-provider name="住所" rules="required|max:255" v-slot="{ errors }" immediate>
              <custom-mdb-input
                class="mb-0"
                label="住所"
                name="address"
                type="text"
                v-model="editAccount.address"
                :customValidation="true"
                :isValid="errors.length == 0"
                :invalidFeedback="errors[0]"
              />
            </validation-provider>
          </mdb-col>
          <mdb-col md="8" offset-md="2" v-show="editAccount.invoiceTo">
            <validation-provider name="電話番号" rules="required|numeric|max:255" v-slot="{ errors }" immediate>
              <custom-mdb-input
                class="mb-0"
                label="電話番号(ハイフンなし半角数字のみ)"
                name="phone"
                type="text"
                v-model="editAccount.phone"
                :customValidation="true"
                :isValid="errors.length == 0"
                :invalidFeedback="errors[0]"
              />
            </validation-provider>
          </mdb-col>
          <mdb-col col="12" md="8" offset-md="2" class="py-2 py-md-4 mt-3">
            <label class="text-muted font-weight-bold">代理店経由の方は「代理店コード」をご入力ください。</label>
            <custom-mdb-input
              class="mb-0"
              label="代理店コード"
              name="agentCode"
              type="text"
              v-model="licensePlan.agentCode"
              :disabled="disabledAgent"
            />
            <custom-mdb-input
              v-if="!disabledAgent"
              class="mt-5 mb-0"
              placeholder="代理店コードが分からない場合はこちらに代理店名等をご入力下さい。"
              name="agentComment"
              type="textarea"
              outline
              v-model="licensePlan.agentComment"
              :rows="5"
            />
          </mdb-col>
        </mdb-row>
        <div class="text-center mt-3 mb-4">
          <mdb-btn
            @click.native="() => requestConfirmModal = true"
            rounded
            color="secondary"
            :class="{ 'disabled': disabledRequestConfirm }"
          >
            申し込み内容確認
          </mdb-btn>
        </div>
        <modal
          :modal="requestConfirmModal"
          size="lg"
          title="申込み内容確認"
          @close="requestConfirmModal = false"
          :disableCancelButton="true"
          :disableOkButton="true"
        >
          <mdb-row>
            <mdb-col v-if="selectedLicensePlanMaster" col="12" class="mt-3">
              <p class="font-weight-bold">ライセンスプラン</p>
              <p class="pl-2">
                {{ selectedLicensePlanMaster.planName }}
              </p>
              <div class="mt-2 mb-4">
                <mdb-tbl responsive bordered class="text-nowrap">
                  <mdb-tbl-head>
                    <tr>
                      <th>利用料金</th>
                      <th>入室者数上限</th>
                      <th>会議時間制限</th>
                    </tr>
                  </mdb-tbl-head>
                  <mdb-tbl-body>
                    <tr>
                      <td>{{ toJPY(selectedLicensePlanMaster.price, true) }}</td>
                      <td>{{ selectedLicensePlanMaster.roomCapacity }}人</td>
                      <td>{{ selectedLicensePlanMaster.maxDuration ? `${selectedLicensePlanMaster.maxDuration}分` : 'なし' }}</td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </mdb-col>
            <mdb-col col="12" class="mt-3" v-if="selectedRoomOptions.length">
              <p class="font-weight-bold">オプション</p>
              <div class="mt-2 mb-4">
                <mdb-tbl responsive bordered class="text-nowrap">
                  <mdb-tbl-head>
                    <tr>
                      <th></th>
                      <th>利用料金</th>
                      <th>オプション説明</th>
                    </tr>
                  </mdb-tbl-head>
                  <mdb-tbl-body>
                    <tr v-for="selectedRoomOption in selectedRoomOptions" :key="selectedRoomOption.resource.id">
                      <td>{{ selectedRoomOption.resource.optionName }}</td>
                      <td>{{ toJPY(selectedRoomOption.resource.price, true) }}</td>
                      <td>
                        <span>{{ selectedRoomOption.resource.optionDescription }}</span>
                        <div v-if="selectedRoomOption.resource.optionType == 'roomReserve'" class="mt-2">
                          <div>
                            <span>専用会議室名: </span>
                            <span class="font-weight-bold text-primary">{{ licensePlan.reservedRoomId }}</span>
                          </div>
                          <div>
                            <span>会議URL: </span>
                            <span class="font-weight-bold text-primary">{{ appURL + licensePlan.reservedRoomId }}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </mdb-col>
            <mdb-col col="12" class="mt-3">
              <p class="font-weight-bold">請求先情報</p>
              <div class="mt-2 mb-4">
                <mdb-tbl responsive bordered class="text-nowrap">
                  <mdb-tbl-body>
                    <tr>
                      <td class="font-weight-bold">請求先</td>
                      <td>{{ editAccount.invoiceTo === 'organization' ? '会社' : '個人' }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">宛先</td>
                      <td>{{ editAccount.invoiceTo === 'organization' ? editAccount.organization : user.name }}</td>
                    </tr>
                    <tr v-if="editAccount.organization">
                      <td class="font-weight-bold">会社名団体名</td>
                      <td>{{ editAccount.organization }}</td>
                    </tr>
                    <tr v-if="editAccount.division">
                      <td class="font-weight-bold">部署名</td>
                      <td>{{ editAccount.division }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">住所</td>
                      <td>{{ editAccount.address }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">電話番号</td>
                      <td>{{ editAccount.phone }}</td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </mdb-col>
            <mdb-col v-if="selectedLicensePlanMaster" col="12" class="mt-3 text-center">
              <small>本契約は一年単位でのご契約となりますので、お申し込み後にWaaarpにご登録のメールアドレス宛に、<br>以下の料金のご請求書をお送りさせていただきます。</small>
              <p class="mt-4">ご請求金額計：{{ toJPY(totalSelectedPrice * 12) }}</p>
            </mdb-col>
          </mdb-row>
          <div class="text-center mt-3 mb-4">
            <div class="d-inline-block clickable" @click="toggleRegulationModal">
              <custom-mdb-input class="disabled" type="checkbox" id="agreed" :label="checkBoxLabel" v-model="agreed"/>
            </div>
          </div>
          <div class="text-center mt-3 mb-4">
            <mdb-btn rounded color="primary" type="submit" :class="{ 'disabled': httpRequesting || !agreed }">
              <span v-if="httpRequesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              申し込み確定
            </mdb-btn>
          </div>
        </modal>
      </form>
    </validation-observer>
    </modal>
    <PaidVersionRegulationModal
      :modal="regulationModal"
      :agreed="agreed"
      @close="regulationModal = false"
      @agreed="regulationModal = false; enabledCheckBox = true;"
    />
    <modal
      v-if="account && account.reservedRoom"
      :modal="showReservedRoomQRModal"
      title="QRコード(専用会議室URL)"
      @close="showReservedRoomQRModal = false"
      :disableOkButton="true"
      :disableCancelButton="true"
    >
     <div class="text-center">
       <vue-qrcode :value="appURL + account.reservedRoom.roomId" :options="{ width: 300 }" tag="img"></vue-qrcode>
     </div>
    </modal>
    <modal
      v-if="account && account.reservedRoom"
      :modal="editReservedRoomIdModal"
      title="専用会議室名変更"
      @accept="onUpdateReservedRoomId"
      @close="editReservedRoomIdModal = false; editReservedRoomId = account.reservedRoom.roomId"
      :disableCancelButton="true"
      :disableOkButton="!validReservedRoomId"
    >
      <custom-mdb-input
        v-model="editReservedRoomId"
        :customValidation="true"
        :isValid="validReservedRoomId"
        :invalidFeedback="reservedRoomIdinvalidFeedback"
        :validFeedback='`入力された会議室名"${editReservedRoomId}"は利用可能です`'
        @input="onInputEditReservedRoomId"
        label="専用会議室名"
        name="roomName"
        type="text"
        class="mb-2"
      />
      <mdb-btn
        v-if="enabledCheckReservedRoomId"
        :class="{ 'disabled': httpRequesting }"
        @click.native="checkEditReservedRoomId"
        rounded
        outline="primary"
        size="sm"
      >
        <span v-if="httpRequesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        会議室名確認
      </mdb-btn>
    </modal>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import Modal from '@/components/molecules/Modal'
import PaidVersionRegulationModal from '@/components/molecules/PaidVersionRegulationModal'

export default {
  name: 'Account',
  components: {
    VueQrcode,
    Modal,
    PaidVersionRegulationModal
  },
  data() {
    return {
      requestFormModal: false,
      requestConfirmModal :false,
      regulationModal: false,
      editReservedRoomId: '',
      showReservedRoomQRModal: false,
      editReservedRoomIdModal: false,
      validated: false,
      roomOptions: [],
      licensePlan: {
        agentCode: '',
        agentComment: '',
        licensePlanMasterId: null,
        reservedRoomId: null,
        roomOptionMasterIds: []
      },
      editAccount: {
        invoiceTo: null, // organization or personal
        organization: '',
        division: '',
        address: '',
        phone: ''
      },
      disabledAgent: false,
      enabledCheckReservedRoomId: false,
      validReservedRoomId: false,
      reservedRoomIdinvalidFeedback: '半角英数字、_(アンダーバー)、-(ハイフン)のみを使用し12文字以上で部屋名を設定してください',
      agreed: false,
      enabledCheckBox: false
    }
  },
  computed: {
    appURL: function() {
      return process.env.VUE_APP_URL
    },
    requestable: function() {
      return this.account
             && this.account.licensedPlan.contractType === 'free'
             && this.account.licensedPlan.planType !== 'admin'
    },
    disabledRequestConfirm: function() {
      return !this.selectedLicensePlanMaster
             || (this.selectedRoomOptions.filter(roomOption => roomOption.resource.optionType == 'roomReserve')[0] && !this.validReservedRoomId)
             || !this.editAccount.invoiceTo
             || (this.editAccount.invoiceTo === 'organization' && !this.editAccount.organization)
             || !this.editAccount.address
             || !this.editAccount.phone
             || this.editAccount.organization.length > 255
             || this.editAccount.division.length > 255
             || this.editAccount.address.length > 255
             || this.editAccount.phone.length > 255
    },
    selectedLicensePlanMaster: function() {
      return this.licensePlanMasters.filter(resource => resource.id == this.licensePlan.licensePlanMasterId)[0]
    },
    selectedRoomOptions: function() {
      return this.roomOptions.filter(roomOption => roomOption.checked)
    },
    totalSelectedPrice: function() {
      if (!this.selectedLicensePlanMaster) return 0
      const selectedRoomOptionsTotalPrice = this.selectedRoomOptions.length ?
                                            this.selectedRoomOptions.map(roomOption => roomOption.resource.price).reduce((a, b) => a + b) :
                                            0
      return this.selectedLicensePlanMaster.price + selectedRoomOptionsTotalPrice
    },
    totalLicensedPrice: function() {
      if (!this.account) return 0
      const licensedRoomOptionsTotalPrice = this.account.licensedPlan.licensedRoomOptions.length ?
                                            this.account.licensedPlan.licensedRoomOptions.map(licensedRoomOption => licensedRoomOption.price).reduce((a, b) => a + b) :
                                            0
      return this.account.licensedPlan.price + licensedRoomOptionsTotalPrice
    },
    checkBoxLabel: function() {
      if (this.enabledCheckBox) {
        return '個人情報の取扱規定、利用規約に同意する'
      } else {
        return '個人情報の取扱規定、利用規約を確認する'
      }
    },
    ...mapGetters({
      user: 'auth/user',
      account: 'account/account',
      licensePlanMasters: 'licensePlanMasters/licensePlanMasters',
      roomOptionMasters: 'roomOptionMasters/roomOptionMasters',
      reservedRoomIdStatus: 'reservedRoom/reservedRoomIdStatus',
      httpRequesting: 'httpRequesting',
      httpSuccess: 'httpSuccess',
      httpError: 'httpError'
    })
  },
  methods: {
    toJPY: function(priceString, monthly = false) {
      return `
        ${priceString.toLocaleString('ja-JP', {'style': 'currency', 'currency': 'JPY'}) + (monthly ? '/月' : '')}
        （税込: ${(priceString * 1.1).toLocaleString('ja-JP', {'style': 'currency', 'currency': 'JPY'}) + (monthly ? '/月' : '')}）
      `
    },
    toggleRegulationModal: function() {
      if (this.agreed) {
        this.agreed = false
        this.enabledCheckBox = false
      } else if (this.enabledCheckBox) {
        this.agreed = true
      } else {
        this.regulationModal = true
      }
    },
    async onUpdateReservedRoomId() {
      await this.apiPutReservedRoom({
        roomId: this.editReservedRoomId
      })
      if (this.httpSuccess) {
        this.editReservedRoomIdModal = false
        await this.apiGetAccount()
      }
    },
    async onSubmit() {
      this.licensePlan.roomOptionMasterIds = this.selectedRoomOptions.map(roomOption => roomOption.resource.id)
      await this.apiPutLicensePlan({
        account: this.editAccount,
        licensePlan: this.licensePlan
      })
      if (this.httpSuccess) {
        this.requestConfirmModal = false
        await this.apiGetAccount()
        this.requestFormModal = false
      }
    },
    onInputEditReservedRoomId: function() {
      this.validReservedRoomId = false
      if (this.account.reservedRoom.roomId == this.editReservedRoomId) {
        this.reservedRoomIdinvalidFeedback = '新しい専用会議室名を入力して下さい'
      }else if (this.editReservedRoomId.match(/^[a-zA-Z0-9-_]{12,}$/) === null) {
        this.reservedRoomIdinvalidFeedback = '半角英数字、_(アンダーバー)、-(ハイフン)のみを使用し12文字以上で部屋名を設定してください'
        this.enabledCheckReservedRoomId = false
      } else {
        this.reservedRoomIdinvalidFeedback = '下記のボタンをクリックし入力された会議室名が既に予約されていないかをチェックして下さい'
        this.enabledCheckReservedRoomId = true
      }
    },
    async checkEditReservedRoomId() {
      await this.apiCheckReservedRoomId({
        room_id: this.editReservedRoomId
      })
      if (!this.httpError) {
        if (this.reservedRoomIdStatus == 'available') {
          this.validReservedRoomId = true
          this.enabledCheckReservedRoomId = false
        } else {
          this.reservedRoomIdinvalidFeedback = `入力された会議室名"${this.editReservedRoomId}"は既に予約されています`
        }
      }
    },
    onInputReservedRoomId: function() {
      this.validReservedRoomId = false
      if (this.licensePlan.reservedRoomId.match(/^[a-zA-Z0-9-_]{12,}$/) === null) {
        this.reservedRoomIdinvalidFeedback = '半角英数字、_(アンダーバー)、-(ハイフン)のみを使用し12文字以上で部屋名を設定してください'
        this.enabledCheckReservedRoomId = false
      } else {
        this.reservedRoomIdinvalidFeedback = '下記のボタンをクリックし入力された会議室名が既に予約されていないかをチェックして下さい'
        this.enabledCheckReservedRoomId = true
      }
    },
    async checkReservedRoomId() {
      await this.apiCheckReservedRoomId({
        room_id: this.licensePlan.reservedRoomId
      })
      if (!this.httpError) {
        if (this.reservedRoomIdStatus == 'available') {
          this.validReservedRoomId = true
          this.enabledCheckReservedRoomId = false
        } else {
          this.reservedRoomIdinvalidFeedback = `入力された会議室名"${this.licensePlan.reservedRoomId}"は既に予約されています`
        }
      }
    },
    ...mapActions({
      apiGetAccount: 'account/show',
      apiPutLicensePlan: 'licensePlan/update',
      apiGetLicensePlanMasters: 'licensePlanMasters/index',
      apiGetRoomOptionMasters: 'roomOptionMasters/index',
      apiCheckReservedRoomId: 'reservedRoom/check',
      apiPutReservedRoom: 'reservedRoom/update'
    })
  },
  async created() {
    await this.apiGetAccount()
    if (this.account.reservedRoom) this.editReservedRoomId = this.account.reservedRoom.roomId

    await this.apiGetLicensePlanMasters()
    await this.apiGetRoomOptionMasters()
    this.roomOptions = this.roomOptionMasters.map(roomOptionMaster => {
      return {
        resource: roomOptionMaster,
        checked: false
      }
    })

    if (this.requestable && this.$route.query.request_type === 'contract') {
      if (this.$route.query.agent_code) {
        this.licensePlan.agentCode = this.$route.query.agent_code
        this.disabledAgent = true
      }
      this.requestFormModal = true
    }
  }
}
</script>

<style scoped lang="scss">
</style>
